<template>
  <div v-if="!isIconField">
    <h4 class="is-size-3 has-text-black-bis order-notes">
      <span class="is-italic has-text-weight-bold line-height">
        Notes
      </span>
      <div class="is-flex is-pulled-right">
        <div class="is-divider-vertical mt-0"></div>
        <button
          class="button px-0 has-text-black-bis"
          v-tooltip="'Edit'"
          @click="editNotes">
          <i class="icon-edit"
            >
          </i>
        </button>
      </div>
    </h4>
    <div class="order-note">
      <div class="column">
        <div class="is-italic has-text-grey-dark is-size-3" v-if="!isIconField">
          <span>{{ userName }}</span>
          <span class="is-pulled-right" v-if="notesText.length">{{$filters.fullDateTime($_.get(order,'lastModified.at', order.createdAt))}}</span>
        </div>
        <div class="is-size-3 note-text-wrap has-text-left">
          {{ notesText }}
        </div>
      </div>
    </div>
  </div>
  <o-modal v-if="isEditable || isActive" :active="isEditable || isActive" :canCancel="false" class="modal-sm">
    <div class="modal-card">
      <header class="modal-card-head has-background-white">
        <div class="modal-card has-text-dark has-text-weight-bold">
          {{ notesType === 'deliveryOrd' ? 'Delivery' : 'Order' }} Note
        </div>
      </header>
      <section class="modal-card-body is-visible  has-background-white pt-2">
        <div class="">
          <div class="is-italic line-height has-text-black-bis has-text-weight-semibold">
            {{ notesType === 'deliveryOrd' ? 'Delivery' : 'Shipping Order' }}
          </div>
          <div class="line-height mb-3 has-text-black-bis">{{ order.name }}</div>
        </div>
        <div class="is-divider my-0"></div>
        <div class="column">
          <div class="is-italic has-text-grey-dark is-size-3 my-2 is-flex is-justify-content-space-between columns">
            <div class="column">{{ userName }}</div>
            <div class="column is-narrow" v-if="isEditable && notesText.length">{{$filters.fullDateTime($_.get(order,'lastModified.at', order.createdAt))}}</div>
            <div class="is-flex is-align-items-center column is-narrow" v-if="!isEditable && isIconField && canEditIconField">
              <span class="has-text-grey-dark is-size-3 is-italic">{{$filters.fullDateTime($_.get(order,'lastModified.at', order.createdAt))}}
                </span>
              <div class="is-divider-vertical"></div>
              <button
                class="button px-0 ml-2 has-text-black-bis"
                v-tooltip="'Edit'"
                @click="editNotes">
                <i class="icon-edit"
                  >
                </i>
              </button>
            </div>
          </div>
        </div>
        <div class="order-note">
          <textarea class="textarea" :disabled="isDisabled"  rows="10" v-model="notesVal"></textarea>
        </div>
      </section>
      <footer class="modal-card-foot is-justify-content-flex-end is-align-items-center has-background-white">
        <div class="buttons" v-if="!isIconField || isEditable">
          <button class="button is-outlined has-text-weight-bold" @click="resetAll">
            Cancel
          </button>
          <button class="button has-text-weight-bold has-background-black-bis has-text-white"
            @click="save">
            Save
          </button>
        </div>
        <div class="buttons" v-else>
          <button class="button has-text-weight-bold has-background-black-bis has-text-white"
            @click="$emit('close')">
            Done
          </button>
        </div>
      </footer>
    </div>
  </o-modal>
</template>

<script>

import { get, trim } from 'lodash';
import { computed, defineComponent, onMounted, reactive, toRefs } from 'vue';
import { useStore } from 'vuex';


export default defineComponent({
  components: {},
  emits: [],
  props: {
    order: {
      type: Object,
      default: () => { },
    },
    prop: {
      type: String,
      default: 'simpleFiles',
    },
    isIconField: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    notesType: {
      type: String,
      default: 'order'
    }
  },

  setup(props, { emit }) {
    const store = useStore();
    const data = reactive({
      isEditable: false,
      notesVal: '',
      userName: '',
    });

    const notesText = computed({
     get: () => {
      const value = get(props.order.delivery, 'notes', '');
        return (typeof value === 'string' || typeof value === 'number') ? trim(String(value)) : '';
      }, 
      set: (val) => {
        if (store.state.activeScreen === 'bim-create') emit('update:value', {notes: val, order: props.order});
        else emit('update:value', val);
      },
    });

    const save = () => {
      notesText.value = trim(data.notesVal);
      data.notesVal = '';
      data.isEditable = false;
      emit('close');
    }

    const editNotes = () => {
      data.isEditable = true;
      data.notesVal = notesText.value;
    }

    const resetAll = () => {
      data.isEditable = false;
      emit('close');
    }

    const isDisabled = computed(() => {
      return props.isIconField && !data.isEditable;
    })

    const canEditIconField = computed(() => {
      if (['unscheduled', 'underDelivered'].includes(props.order.id)) {
        return false;
      }
      return true;
    })

    onMounted(async () => {
      const user = await store.getters.userPromise;
      data.userName = user.name;
      if (props.isIconField) {
        data.notesVal = notesText.value;
      }
    })

    return {
      ...toRefs(data),
      notesText,
      editNotes,
      resetAll,
      save,
      isDisabled,
      canEditIconField
    }
  }
})
</script>

<style scoped>
  .o-modal__content .modal-card-head {
    border-bottom: none;
  }
  .o-modal__content .modal-card-foot {
    border-top: 1px solid #a6a6a6;
  }
  .is-divider {
    margin: 0 !important;
    margin-top: 16px !important;
    border-color: #999999;
  }
  .textarea {
    border: none !important;
    box-shadow: none !important;
  }
</style>